import type { PageComponent } from '../../router'
import { SettingsPageController } from './SettingsPageController'
import { settingsPageTemplate } from './settingsPageTemplates'

/** Keeps the settings form mounted for the authenticated session. */
const SettingsPage: PageComponent = {
	async mount(context) {
		const { containerEl, user, signal } = context
		if (!user) throw new Error('Authentication required')
		containerEl.innerHTML = settingsPageTemplate()
		const root = containerEl.querySelector<HTMLElement>('#settings-section')
		if (!root) throw new Error('Missing settings page')

		const controller = new SettingsPageController(root, user)
		signal.addEventListener('abort', () => controller.dispose(), {
			once: true,
		})

		signal.throwIfAborted()
		return controller
	},
}

export default SettingsPage
